export default __webpack_public_path__ + "static/media/add-member-bg.f0dac0a8.svg";